import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vModelSelect as _vModelSelect, vModelCheckbox as _vModelCheckbox, createBlock as _createBlock } from "vue";
const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white add-user-card" };
const _hoisted_2 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing" };
const _hoisted_3 = { class: "row" };
const _hoisted_4 = { class: "col-md-12 mb-25" };
const _hoisted_5 = { class: "d-block text-black fw-semibold mb-10" };
const _hoisted_6 = {
    key: 0,
    class: "upload-placeholder p-20"
};
const _hoisted_7 = {
    key: 1,
    class: "image-preview-wrapper position-relative inline-block"
};
const _hoisted_8 = ["src"];
const _hoisted_9 = { class: "col-md-12" };
const _hoisted_10 = { class: "form-group mb-15 mb-sm-20 mb-md-25" };
const _hoisted_11 = { class: "d-block text-black fw-semibold mb-10" };
const _hoisted_12 = ["placeholder"];
const _hoisted_13 = { class: "col-md-6" };
const _hoisted_14 = { class: "form-group mb-15 mb-sm-20 mb-md-25" };
const _hoisted_15 = { class: "d-block text-black fw-semibold mb-10" };
const _hoisted_16 = { class: "col-md-6" };
const _hoisted_17 = { class: "form-group mb-15 mb-sm-20 mb-md-25" };
const _hoisted_18 = { class: "d-block text-black fw-semibold mb-10" };
const _hoisted_19 = { class: "col-md-12" };
const _hoisted_20 = { class: "form-group mb-15 mb-sm-20 mb-md-25" };
const _hoisted_21 = { class: "d-block text-black fw-semibold mb-10" };
const _hoisted_22 = { class: "col-md-6" };
const _hoisted_23 = { class: "form-group mb-15 mb-sm-20 mb-md-25" };
const _hoisted_24 = { class: "d-block text-black fw-semibold mb-10" };
const _hoisted_25 = ["placeholder"];
const _hoisted_26 = { class: "col-md-6" };
const _hoisted_27 = { class: "form-group mb-15 mb-sm-20 mb-md-25" };
const _hoisted_28 = { class: "d-block text-black fw-semibold mb-10" };
const _hoisted_29 = ["placeholder"];
const _hoisted_30 = { class: "col-md-6" };
const _hoisted_31 = { class: "form-group mb-15 mb-sm-20 mb-md-25" };
const _hoisted_32 = { class: "d-block text-black fw-semibold mb-10" };
const _hoisted_33 = ["placeholder"];
const _hoisted_34 = { class: "col-md-6" };
const _hoisted_35 = { class: "form-group mb-15 mb-sm-20 mb-md-25" };
const _hoisted_36 = { class: "d-block text-black fw-semibold mb-10" };
const _hoisted_37 = { class: "col-md-6" };
const _hoisted_38 = { class: "form-group mb-15 mb-sm-20 mb-md-25" };
const _hoisted_39 = { class: "d-block text-black fw-semibold mb-10" };
const _hoisted_40 = ["placeholder"];
const _hoisted_41 = { class: "col-md-6" };
const _hoisted_42 = { class: "form-group mb-15 mb-sm-20 mb-md-25" };
const _hoisted_43 = { class: "d-block text-black fw-semibold mb-10" };
const _hoisted_44 = ["placeholder", "required"];
const _hoisted_45 = { class: "col-md-6" };
const _hoisted_46 = { class: "form-group mb-15 mb-sm-20 mb-md-25" };
const _hoisted_47 = { class: "d-block text-black fw-semibold mb-10" };
const _hoisted_48 = { selected: "" };
const _hoisted_49 = { class: "col-md-6" };
const _hoisted_50 = { class: "form-group mb-15 mb-sm-20 mb-md-25" };
const _hoisted_51 = { class: "d-block text-black fw-semibold mb-10" };
const _hoisted_52 = ["placeholder"];
const _hoisted_53 = { class: "col-md-6" };
const _hoisted_54 = { class: "form-group mb-15 mb-sm-20 mb-md-25" };
const _hoisted_55 = { class: "d-block text-black fw-semibold mb-10" };
const _hoisted_56 = ["placeholder"];
const _hoisted_57 = { class: "col-md-6" };
const _hoisted_58 = { class: "form-group mb-15 mb-sm-20 mb-md-25" };
const _hoisted_59 = { class: "d-block text-black fw-semibold mb-10" };
const _hoisted_60 = ["placeholder"];
const _hoisted_61 = { class: "col-md-6" };
const _hoisted_62 = { class: "form-group mb-15 mb-sm-20 mb-md-25" };
const _hoisted_63 = { class: "d-block text-black fw-semibold mb-10" };
const _hoisted_64 = ["placeholder"];
const _hoisted_65 = { class: "col-md-12" };
const _hoisted_66 = { class: "row" };
const _hoisted_67 = { class: "col-md-4 mb-20" };
const _hoisted_68 = { class: "form-check form-switch px-0 ms-40" };
const _hoisted_69 = {
    class: "form-check-label fw-semibold text-black ms-2",
    for: "allow_order_modification",
    style: { "cursor": "pointer" }
};
const _hoisted_70 = { class: "col-md-4 mb-20" };
const _hoisted_71 = { class: "form-check form-switch px-0 ms-40" };
const _hoisted_72 = {
    class: "form-check-label fw-semibold text-black ms-2",
    for: "allow_order_deletion",
    style: { "cursor": "pointer" }
};
const _hoisted_73 = { class: "col-md-4 mb-20" };
const _hoisted_74 = { class: "form-check form-switch px-0 ms-40" };
const _hoisted_75 = {
    class: "form-check-label fw-semibold text-black ms-2",
    for: "show_google_maps_qr",
    style: { "cursor": "pointer" }
};
const _hoisted_76 = { class: "col-md-12" };
const _hoisted_77 = { class: "row" };
const _hoisted_78 = { class: "col-md-6 mb-20" };
const _hoisted_79 = { class: "form-check form-switch px-0 ms-40" };
const _hoisted_80 = { class: "col-md-6 mb-20" };
const _hoisted_81 = { class: "form-check form-switch px-0 ms-40" };
const _hoisted_82 = { class: "col-md-12" };
const _hoisted_83 = { class: "form-group mb-15 mb-sm-20 mb-md-25" };
const _hoisted_84 = { class: "col-md-6" };
const _hoisted_85 = { class: "form-group mb-15 mb-sm-20 mb-md-25" };
const _hoisted_86 = { class: "col-md-6" };
const _hoisted_87 = { class: "form-group mb-15 mb-sm-20 mb-md-25" };
const _hoisted_88 = {
    key: 0,
    class: "col-md-12"
};
const _hoisted_89 = { class: "col-md-12" };
const _hoisted_90 = { class: "d-flex align-items-center justify-content-between" };
const _hoisted_91 = ["disabled"];
const _hoisted_92 = { class: "position-relative" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_v_select = _resolveComponent("v-select");
    const _component_VabenePosClientManager = _resolveComponent("VabenePosClientManager");
    const _component_LoaderComponent = _resolveComponent("LoaderComponent");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
            _createElementVNode("form", {
                onSubmit: _cache[43] || (_cache[43] = _withModifiers(
                //@ts-ignore
                (...args) => (_ctx.createRestaurantAccount && _ctx.createRestaurantAccount(...args)), ["prevent"]))
            }, [
                _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("div", _hoisted_4, [
                        _createElementVNode("label", _hoisted_5, _toDisplayString(_ctx.$t('forms.restaurantImage') || 'Image du restaurant'), 1),
                        _createElementVNode("div", {
                            class: _normalizeClass(["image-upload-container border p-20 text-center cursor-pointer position-relative", { 'has-image': _ctx.imagePreview }]),
                            onClick: _cache[2] || (_cache[2] =
                                //@ts-ignore
                                (...args) => (_ctx.triggerFileUpload && _ctx.triggerFileUpload(...args))),
                            onDragover: _cache[3] || (_cache[3] = _withModifiers(() => { }, ["prevent"])),
                            onDrop: _cache[4] || (_cache[4] = _withModifiers(
                            //@ts-ignore
                            (...args) => (_ctx.onFileDrop && _ctx.onFileDrop(...args)), ["prevent"])),
                            style: { "border-style": "dashed !important", "border-width": "2px !important", "border-color": "#dee2e6 !important" }
                        }, [
                            _createElementVNode("input", {
                                type: "file",
                                ref: "fileInput",
                                class: "d-none",
                                accept: "image/*",
                                onChange: _cache[0] || (_cache[0] =
                                    //@ts-ignore
                                    (...args) => (_ctx.onFileChange && _ctx.onFileChange(...args)))
                            }, null, 544),
                            (!_ctx.imagePreview)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_6, [...(_cache[44] || (_cache[44] = [
                                        _createElementVNode("i", { class: "ri-image-add-line fs-1 text-muted d-block mb-10" }, null, -1),
                                        _createElementVNode("span", { class: "text-muted small" }, "Cliquez ou glissez-déposez une image ici", -1),
                                        _createElementVNode("p", { class: "text-muted extra-small mt-5" }, "(JPG, PNG, WebP - Max 5 Mo)", -1)
                                    ]))]))
                                : (_openBlock(), _createElementBlock("div", _hoisted_7, [
                                    _createElementVNode("img", {
                                        src: _ctx.imagePreview,
                                        alt: "Preview",
                                        class: "img-fluid rounded shadow-sm",
                                        style: { "max-height": "200px", "object-fit": "cover" }
                                    }, null, 8, _hoisted_8),
                                    _createElementVNode("button", {
                                        type: "button",
                                        class: "btn btn-danger btn-sm position-absolute top-0 end-0 m-2 rounded-circle p-0",
                                        style: { "width": "25px", "height": "25px", "line-height": "25px" },
                                        onClick: _cache[1] || (_cache[1] = _withModifiers(
                                        //@ts-ignore
                                        (...args) => (_ctx.removeImage && _ctx.removeImage(...args)), ["stop"]))
                                    }, [...(_cache[45] || (_cache[45] = [
                                            _createElementVNode("i", { class: "ri-close-line" }, null, -1)
                                        ]))])
                                ]))
                        ], 34)
                    ]),
                    _createElementVNode("div", _hoisted_9, [
                        _createElementVNode("div", _hoisted_10, [
                            _createElementVNode("label", _hoisted_11, _toDisplayString(_ctx.$t('forms.restaurantName')) + " * ", 1),
                            _withDirectives(_createElementVNode("input", {
                                type: "text",
                                class: _normalizeClass(["form-control shadow-none rounded-0 text-black", { 'is-valid': _ctx.validTextField(_ctx.restaurantData.name) }]),
                                placeholder: _ctx.$t('forms.example') + ' Applicium Restaurant',
                                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => ((_ctx.restaurantData.name) = $event)),
                                onChange: _cache[6] || (_cache[6] = (event) => _ctx.handleInput(event, 'name')),
                                required: ""
                            }, null, 42, _hoisted_12), [
                                [_vModelText, _ctx.restaurantData.name]
                            ])
                        ])
                    ]),
                    _createElementVNode("div", _hoisted_13, [
                        _createElementVNode("div", _hoisted_14, [
                            _createElementVNode("label", _hoisted_15, _toDisplayString(_ctx.$t('forms.companyName') || 'Raison sociale'), 1),
                            _withDirectives(_createElementVNode("input", {
                                type: "text",
                                class: _normalizeClass(["form-control shadow-none rounded-0 text-black", { 'is-valid': _ctx.validTextField(_ctx.restaurantData.raison_sociale) }]),
                                placeholder: "Ex: Applicium ",
                                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event) => ((_ctx.restaurantData.raison_sociale) = $event)),
                                onChange: _cache[8] || (_cache[8] = (event) => _ctx.handleInput(event, 'raison_sociale'))
                            }, null, 34), [
                                [_vModelText, _ctx.restaurantData.raison_sociale]
                            ])
                        ])
                    ]),
                    _createElementVNode("div", _hoisted_16, [
                        _createElementVNode("div", _hoisted_17, [
                            _createElementVNode("label", _hoisted_18, _toDisplayString(_ctx.$t('forms.website') || 'Site Web'), 1),
                            _withDirectives(_createElementVNode("input", {
                                type: "text",
                                class: _normalizeClass(["form-control shadow-none rounded-0 text-black", { 'is-valid': _ctx.validTextField(_ctx.restaurantData.site_web) }]),
                                placeholder: "https://www.applicium.com",
                                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event) => ((_ctx.restaurantData.site_web) = $event)),
                                onChange: _cache[10] || (_cache[10] = (event) => _ctx.handleInput(event, 'site_web'))
                            }, null, 34), [
                                [_vModelText, _ctx.restaurantData.site_web]
                            ])
                        ])
                    ]),
                    _createElementVNode("div", _hoisted_19, [
                        _createElementVNode("div", _hoisted_20, [
                            _createElementVNode("label", _hoisted_21, _toDisplayString(_ctx.$t('lists.searchUser') || 'Rechercher un responsable'), 1),
                            _createVNode(_component_v_select, {
                                modelValue: _ctx.userSelected,
                                "onUpdate:modelValue": [
                                    _cache[11] || (_cache[11] = ($event) => ((_ctx.userSelected) = $event)),
                                    _ctx.onUserSelect
                                ],
                                options: _ctx.originalUsers,
                                label: "email",
                                reduce: user => user.id,
                                filterable: true,
                                onSearch: _ctx.onSearchUsers,
                                loading: _ctx.isLoadingUsers,
                                placeholder: "Rechercher par e-mail ou nom...",
                                class: "bg-white"
                            }, {
                                option: _withCtx((option) => [
                                    _createElementVNode("span", null, _toDisplayString(option.first_name) + " " + _toDisplayString(option.last_name) + " (" + _toDisplayString(option.email) + ")", 1)
                                ]),
                                "selected-option": _withCtx((option) => [
                                    _createTextVNode(_toDisplayString(option.first_name) + " " + _toDisplayString(option.last_name), 1)
                                ]),
                                _: 1
                            }, 8, ["modelValue", "options", "reduce", "onSearch", "loading", "onUpdate:modelValue"])
                        ])
                    ]),
                    _createElementVNode("div", _hoisted_22, [
                        _createElementVNode("div", _hoisted_23, [
                            _createElementVNode("label", _hoisted_24, _toDisplayString(_ctx.$t('forms.managerFirstName')) + " * ", 1),
                            _withDirectives(_createElementVNode("input", {
                                type: "text",
                                class: _normalizeClass(["form-control shadow-none rounded-0 text-black", { 'is-valid': _ctx.validTextField(_ctx.restaurantData.firstName) }]),
                                placeholder: _ctx.$t('forms.example') + ' Adam',
                                "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event) => ((_ctx.restaurantData.firstName) = $event)),
                                onChange: _cache[13] || (_cache[13] = (event) => _ctx.handleInput(event, 'firstName')),
                                required: "",
                                readonly: "",
                                disabled: ""
                            }, null, 42, _hoisted_25), [
                                [_vModelText, _ctx.restaurantData.firstName]
                            ])
                        ])
                    ]),
                    _createElementVNode("div", _hoisted_26, [
                        _createElementVNode("div", _hoisted_27, [
                            _createElementVNode("label", _hoisted_28, _toDisplayString(_ctx.$t('forms.managerLastName')) + " * ", 1),
                            _withDirectives(_createElementVNode("input", {
                                type: "text",
                                class: _normalizeClass(["form-control shadow-none rounded-0 text-black", { 'is-valid': _ctx.validTextField(_ctx.restaurantData.lastName) }]),
                                placeholder: _ctx.$t('forms.example') + ' Smith',
                                "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event) => ((_ctx.restaurantData.lastName) = $event)),
                                onChange: _cache[15] || (_cache[15] = (event) => _ctx.handleInput(event, 'lastName')),
                                required: "",
                                readonly: "",
                                disabled: ""
                            }, null, 42, _hoisted_29), [
                                [_vModelText, _ctx.restaurantData.lastName]
                            ])
                        ])
                    ]),
                    _createElementVNode("div", _hoisted_30, [
                        _createElementVNode("div", _hoisted_31, [
                            _createElementVNode("label", _hoisted_32, _toDisplayString(_ctx.$t('forms.vatNumber')) + " * ", 1),
                            _withDirectives(_createElementVNode("input", {
                                type: "text",
                                class: _normalizeClass(["form-control shadow-none rounded-0 text-black", { 'is-valid': _ctx.validTextField(_ctx.restaurantData.taxe) }]),
                                placeholder: _ctx.$t('forms.example') + ' CHE-372.776.093 TVA',
                                "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event) => ((_ctx.restaurantData.taxe) = $event)),
                                onChange: _cache[17] || (_cache[17] = (event) => _ctx.handleInput(event, 'taxe')),
                                required: ""
                            }, null, 42, _hoisted_33), [
                                [_vModelText, _ctx.restaurantData.taxe]
                            ])
                        ])
                    ]),
                    _createElementVNode("div", _hoisted_34, [
                        _createElementVNode("div", _hoisted_35, [
                            _createElementVNode("label", _hoisted_36, _toDisplayString(_ctx.$t('forms.vatRate')), 1),
                            _withDirectives(_createElementVNode("input", {
                                type: "number",
                                step: "0.05",
                                min: "0",
                                max: "100",
                                class: "form-control shadow-none rounded-0 text-black",
                                placeholder: "e.g. 2.6",
                                "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event) => ((_ctx.restaurantData.taxValue) = $event)),
                                onChange: _cache[19] || (_cache[19] = (event) => _ctx.handleInput(event, 'taxValue'))
                            }, null, 544), [
                                [_vModelText, _ctx.restaurantData.taxValue]
                            ])
                        ])
                    ]),
                    _createElementVNode("div", _hoisted_37, [
                        _createElementVNode("div", _hoisted_38, [
                            _createElementVNode("label", _hoisted_39, _toDisplayString(_ctx.$t('forms.phoneNumber')), 1),
                            _withDirectives(_createElementVNode("input", {
                                type: "text",
                                class: _normalizeClass(["form-control shadow-none rounded-0 text-black", { 'is-valid': _ctx.validTextField(_ctx.restaurantData.phone_number) }]),
                                placeholder: _ctx.$t('forms.example') + ' +338830003',
                                "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event) => ((_ctx.restaurantData.phone_number) = $event)),
                                onChange: _cache[21] || (_cache[21] = (event) => _ctx.handleInput(event, 'phone_number'))
                            }, null, 42, _hoisted_40), [
                                [_vModelText, _ctx.restaurantData.phone_number]
                            ])
                        ])
                    ]),
                    _createElementVNode("div", _hoisted_41, [
                        _createElementVNode("div", _hoisted_42, [
                            _createElementVNode("label", _hoisted_43, _toDisplayString(_ctx.$t('auth.email')) + " * ", 1),
                            _withDirectives(_createElementVNode("input", {
                                type: "email",
                                "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event) => ((_ctx.restaurantData.email) = $event)),
                                onChange: _cache[23] || (_cache[23] = (event) => _ctx.handleInput(event, 'email')),
                                class: _normalizeClass([{ 'is-valid': _ctx.validEmail(_ctx.restaurantData.email) }, "form-control shadow-none rounded-0 text-black bg-light"]),
                                placeholder: _ctx.$t('forms.example') + ' adam127704@gmail.com',
                                required: _ctx.actionDetected === _ctx.ActionCrud.ADD,
                                readonly: "",
                                disabled: ""
                            }, null, 42, _hoisted_44), [
                                [_vModelText, _ctx.restaurantData.email]
                            ])
                        ])
                    ]),
                    _createElementVNode("div", _hoisted_45, [
                        _createElementVNode("div", _hoisted_46, [
                            _createElementVNode("label", _hoisted_47, _toDisplayString(_ctx.$t('forms.country')) + "* ", 1),
                            _withDirectives(_createElementVNode("select", {
                                "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event) => ((_ctx.restaurantData.country) = $event)),
                                class: _normalizeClass(["form-select shadow-none fw-semibold rounded-0", { 'is-valid': _ctx.validTextField(_ctx.restaurantData.country) }]),
                                onChange: _cache[25] || (_cache[25] = (event) => _ctx.handleInput(event, 'country'))
                            }, [
                                _createElementVNode("option", _hoisted_48, _toDisplayString(_ctx.$t('forms.switzerland')), 1)
                            ], 34), [
                                [_vModelSelect, _ctx.restaurantData.country]
                            ])
                        ])
                    ]),
                    _createElementVNode("div", _hoisted_49, [
                        _createElementVNode("div", _hoisted_50, [
                            _createElementVNode("label", _hoisted_51, _toDisplayString(_ctx.$t('forms.postalCode')) + " * ", 1),
                            _withDirectives(_createElementVNode("input", {
                                type: "text",
                                class: _normalizeClass(["form-control shadow-none rounded-0 text-black", { 'is-valid': _ctx.validTextField(_ctx.restaurantData.postalCodeID) }]),
                                placeholder: _ctx.$t('forms.example') + ' 1110',
                                "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event) => ((_ctx.restaurantData.postalCodeID) = $event)),
                                onChange: _cache[27] || (_cache[27] = (event) => _ctx.handleInput(event, 'postalCode')),
                                required: ""
                            }, null, 42, _hoisted_52), [
                                [_vModelText, _ctx.restaurantData.postalCodeID]
                            ])
                        ])
                    ]),
                    _createElementVNode("div", _hoisted_53, [
                        _createElementVNode("div", _hoisted_54, [
                            _createElementVNode("label", _hoisted_55, _toDisplayString(_ctx.$t('forms.city')), 1),
                            _withDirectives(_createElementVNode("input", {
                                type: "text",
                                class: _normalizeClass(["form-control shadow-none rounded-0 text-black", { 'is-valid': _ctx.validTextField(_ctx.restaurantData.city) }]),
                                placeholder: _ctx.$t('forms.example') + ' Morges',
                                "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event) => ((_ctx.restaurantData.city) = $event)),
                                onChange: _cache[29] || (_cache[29] = (event) => _ctx.handleInput(event, 'city')),
                                required: ""
                            }, null, 42, _hoisted_56), [
                                [_vModelText, _ctx.restaurantData.city]
                            ])
                        ])
                    ]),
                    _createElementVNode("div", _hoisted_57, [
                        _createElementVNode("div", _hoisted_58, [
                            _createElementVNode("label", _hoisted_59, _toDisplayString(_ctx.$t('forms.address')), 1),
                            _withDirectives(_createElementVNode("input", {
                                type: "text",
                                class: _normalizeClass(["form-control shadow-none rounded-0 text-black", { 'is-valid': _ctx.validTextField(_ctx.restaurantData.address) }]),
                                placeholder: _ctx.$t('forms.example') + ' Rue 44 batiment 34',
                                "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event) => ((_ctx.restaurantData.address) = $event)),
                                onChange: _cache[31] || (_cache[31] = (event) => _ctx.handleInput(event, 'address'))
                            }, null, 42, _hoisted_60), [
                                [_vModelText, _ctx.restaurantData.address]
                            ])
                        ])
                    ]),
                    _createElementVNode("div", _hoisted_61, [
                        _createElementVNode("div", _hoisted_62, [
                            _createElementVNode("label", _hoisted_63, _toDisplayString(_ctx.$t('forms.streetNumber')) + " * ", 1),
                            _withDirectives(_createElementVNode("input", {
                                type: "text",
                                class: _normalizeClass(["form-control shadow-none rounded-0 text-black", { 'is-valid': _ctx.validTextField(_ctx.restaurantData.numeroRue) }]),
                                placeholder: _ctx.$t('forms.example') + ' 34662',
                                "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event) => ((_ctx.restaurantData.numeroRue) = $event)),
                                onChange: _cache[33] || (_cache[33] = (event) => _ctx.handleInput(event, 'numeroRue')),
                                required: ""
                            }, null, 42, _hoisted_64), [
                                [_vModelText, _ctx.restaurantData.numeroRue]
                            ])
                        ])
                    ]),
                    _createElementVNode("div", _hoisted_65, [
                        _createElementVNode("div", _hoisted_66, [
                            _createElementVNode("div", _hoisted_67, [
                                _createElementVNode("div", _hoisted_68, [
                                    _withDirectives(_createElementVNode("input", {
                                        class: "form-check-input shadow-none ms-0",
                                        type: "checkbox",
                                        id: "allow_order_modification",
                                        "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event) => ((_ctx.restaurantData.allow_order_modification) = $event))
                                    }, null, 512), [
                                        [_vModelCheckbox, _ctx.restaurantData.allow_order_modification]
                                    ]),
                                    _createElementVNode("label", _hoisted_69, _toDisplayString(_ctx.$t('forms.allowOrderModification') || ''), 1)
                                ])
                            ]),
                            _createElementVNode("div", _hoisted_70, [
                                _createElementVNode("div", _hoisted_71, [
                                    _withDirectives(_createElementVNode("input", {
                                        class: "form-check-input shadow-none ms-0",
                                        type: "checkbox",
                                        id: "allow_order_deletion",
                                        "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event) => ((_ctx.restaurantData.allow_order_deletion) = $event))
                                    }, null, 512), [
                                        [_vModelCheckbox, _ctx.restaurantData.allow_order_deletion]
                                    ]),
                                    _createElementVNode("label", _hoisted_72, _toDisplayString(_ctx.$t('forms.allowOrderDeletion') || ''), 1)
                                ])
                            ]),
                            _createElementVNode("div", _hoisted_73, [
                                _createElementVNode("div", _hoisted_74, [
                                    _withDirectives(_createElementVNode("input", {
                                        class: "form-check-input shadow-none ms-0",
                                        type: "checkbox",
                                        id: "show_google_maps_qr",
                                        "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event) => ((_ctx.restaurantData.show_google_maps_qr) = $event))
                                    }, null, 512), [
                                        [_vModelCheckbox, _ctx.restaurantData.show_google_maps_qr]
                                    ]),
                                    _createElementVNode("label", _hoisted_75, _toDisplayString(_ctx.$t('forms.showGoogleMapsQr') || ''), 1)
                                ])
                            ])
                        ])
                    ]),
                    _cache[55] || (_cache[55] = _createElementVNode("div", { class: "col-md-12 mb-4 mt-4" }, [
                        _createElementVNode("h5", { class: "text-black fw-bold mb-3" }, "Cartes Cadeaux"),
                        _createElementVNode("hr"),
                        _createElementVNode("p", { class: "text-muted small mb-4" }, "Activer ou désactiver les ventes de cartes cadeaux pour ce restaurant.")
                    ], -1)),
                    _createElementVNode("div", _hoisted_76, [
                        _createElementVNode("div", _hoisted_77, [
                            _createElementVNode("div", _hoisted_78, [
                                _createElementVNode("div", _hoisted_79, [
                                    _withDirectives(_createElementVNode("input", {
                                        class: "form-check-input shadow-none ms-0",
                                        type: "checkbox",
                                        id: "isDigitalEnabled",
                                        "onUpdate:modelValue": _cache[37] || (_cache[37] = ($event) => ((_ctx.restaurantData.isDigitalEnabled) = $event))
                                    }, null, 512), [
                                        [_vModelCheckbox, _ctx.restaurantData.isDigitalEnabled]
                                    ]),
                                    _cache[46] || (_cache[46] = _createElementVNode("label", {
                                        class: "form-check-label fw-semibold text-black ms-2",
                                        for: "isDigitalEnabled",
                                        style: { "cursor": "pointer" }
                                    }, " Activer Cartes Digitales ", -1))
                                ])
                            ]),
                            _createElementVNode("div", _hoisted_80, [
                                _createElementVNode("div", _hoisted_81, [
                                    _withDirectives(_createElementVNode("input", {
                                        class: "form-check-input shadow-none ms-0",
                                        type: "checkbox",
                                        id: "isPhysicalEnabled",
                                        "onUpdate:modelValue": _cache[38] || (_cache[38] = ($event) => ((_ctx.restaurantData.isPhysicalEnabled) = $event))
                                    }, null, 512), [
                                        [_vModelCheckbox, _ctx.restaurantData.isPhysicalEnabled]
                                    ]),
                                    _cache[47] || (_cache[47] = _createElementVNode("label", {
                                        class: "form-check-label fw-semibold text-black ms-2",
                                        for: "isPhysicalEnabled",
                                        style: { "cursor": "pointer" }
                                    }, " Activer Cartes Physiques ", -1))
                                ])
                            ])
                        ])
                    ]),
                    _cache[56] || (_cache[56] = _createElementVNode("div", { class: "col-md-12 mb-4 mt-4" }, [
                        _createElementVNode("h5", { class: "text-black fw-bold mb-3" }, "Configuration WhatsApp"),
                        _createElementVNode("hr"),
                        _createElementVNode("p", { class: "text-muted small mb-4" }, "Si activé au niveau de la franchise, ces informations permettront aux clients de vous contacter directement depuis le site web.")
                    ], -1)),
                    _createElementVNode("div", _hoisted_82, [
                        _createElementVNode("div", _hoisted_83, [
                            _cache[48] || (_cache[48] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Numéro WhatsApp (Format international obligatoire) * ", -1)),
                            _withDirectives(_createElementVNode("input", {
                                type: "text",
                                class: "form-control shadow-none rounded-0 text-black",
                                placeholder: "Ex: +41781234567",
                                "onUpdate:modelValue": _cache[39] || (_cache[39] = ($event) => ((_ctx.restaurantData.whatsapp_number) = $event))
                            }, null, 512), [
                                [_vModelText, _ctx.restaurantData.whatsapp_number]
                            ]),
                            _cache[49] || (_cache[49] = _createElementVNode("small", { class: "text-muted" }, "Incluez l'indicatif pays (ex: +41 pour la Suisse, +33 pour la France) sans espaces.", -1))
                        ])
                    ]),
                    _createElementVNode("div", _hoisted_84, [
                        _createElementVNode("div", _hoisted_85, [
                            _cache[50] || (_cache[50] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Message Type : Commande ", -1)),
                            _withDirectives(_createElementVNode("textarea", {
                                class: "form-control shadow-none rounded-0 text-black",
                                rows: "3",
                                placeholder: "Ex: Bonjour, je souhaiterais passer une commande...",
                                "onUpdate:modelValue": _cache[40] || (_cache[40] = ($event) => ((_ctx.restaurantData.whatsapp_order_message) = $event))
                            }, null, 512), [
                                [_vModelText, _ctx.restaurantData.whatsapp_order_message]
                            ]),
                            _cache[51] || (_cache[51] = _createElementVNode("small", { class: "text-muted" }, "Ce message sera pré-rempli quand le client cliquera sur \"Commander\".", -1))
                        ])
                    ]),
                    _createElementVNode("div", _hoisted_86, [
                        _createElementVNode("div", _hoisted_87, [
                            _cache[52] || (_cache[52] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Message Type : Réclamation / Aide ", -1)),
                            _withDirectives(_createElementVNode("textarea", {
                                class: "form-control shadow-none rounded-0 text-black",
                                rows: "3",
                                placeholder: "Ex: Bonjour, j'ai rencontré un problème avec ma commande...",
                                "onUpdate:modelValue": _cache[41] || (_cache[41] = ($event) => ((_ctx.restaurantData.whatsapp_complaint_message) = $event))
                            }, null, 512), [
                                [_vModelText, _ctx.restaurantData.whatsapp_complaint_message]
                            ]),
                            _cache[53] || (_cache[53] = _createElementVNode("small", { class: "text-muted" }, "Ce message sera pré-rempli quand le client cliquera sur \"Réclamation\".", -1))
                        ])
                    ]),
                    (_ctx.actionDetected === _ctx.ActionCrud.EDIT && _ctx.restaurantID)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_88, [
                            _createVNode(_component_VabenePosClientManager, { restaurantId: _ctx.restaurantID }, null, 8, ["restaurantId"])
                        ]))
                        : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_89, [
                        _createElementVNode("div", _hoisted_90, [
                            (_ctx.isLoading)
                                ? (_openBlock(), _createBlock(_component_LoaderComponent, { key: 0 }))
                                : (_openBlock(), _createElementBlock("button", {
                                    key: 1,
                                    class: _normalizeClass(["default-btn transition border-0 fw-medium text-white pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-35 pe-md-35 rounded-1 fs-md-15 fs-lg-16 bg-success", { 'opacity-50 cursor-not-allowed': !_ctx.isFormValid }]),
                                    type: "submit",
                                    disabled: !_ctx.isFormValid
                                }, _toDisplayString(_ctx.actionDetected === 'edit' ? _ctx.$t('common.save') : _ctx.$t('lists.addRestaurant')), 11, _hoisted_91)),
                            _createElementVNode("button", {
                                type: "button",
                                onClick: _cache[42] || (_cache[42] =
                                    //@ts-ignore
                                    (...args) => (_ctx.goBack && _ctx.goBack(...args))),
                                class: "bg-transparent p-0 border-0 text-danger lh-1 fw-medium"
                            }, [
                                _cache[54] || (_cache[54] = _createElementVNode("i", { class: "flaticon-delete lh-1 me-1 position-relative top-2" }, null, -1)),
                                _createElementVNode("span", _hoisted_92, _toDisplayString(_ctx.$t('common.cancel')), 1)
                            ])
                        ])
                    ])
                ])
            ], 32)
        ])
    ]));
}
